export const bookDetailPath = {
  path: '/books/'
}